import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import storyDetailListWrapperCss from '../assets/detail/story-detail-list-wrapper.module.scss';

const StoryDetailListWrapperTitle: FC = () => (
  <div className={storyDetailListWrapperCss.storyDetailListWrapper__title}>
    <FormattedMessage defaultMessage="Stories" />
  </div>
);

export { StoryDetailListWrapperTitle };
